export default __webpack_public_path__ + "static/revops-674c82add5baf501b9f5607b25d4815d.png";